import { useQuery } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../../orpc'
import { DutyStatus } from '@@api/router'

export function useRosterCheckExistingInRange(
  crewId: string | null,
  startDate: string | null, // YYYY-MM-DD
  endDate: string | null // YYYY-MM-DD
) {
  const orpc = useOrpcTanstackQueryUtils()
  const enabled = !!crewId && !!startDate && !!endDate
  return useQuery(
    orpc.roster.checkExistingInRange.queryOptions({
      input: {
        crewId: crewId!,
        startDate: startDate!,
        endDate: endDate!,
      },
      gcTime: 0,
      enabled,
    })
  )
}

export function useRosterCheckFlightAssignments(
  crewId: string | null,
  startDate: string | null, // YYYY-MM-DD
  endDate: string | null, // YYYY-MM-DD
  dutyStatus: DutyStatus | null
) {
  const orpc = useOrpcTanstackQueryUtils()
  // Only check flight assignments when changing to a non-eligible duty status
  // Standby crew should not be assigned to flights either
  const isNonEligibleStatus = dutyStatus === 'OffDuty' || dutyStatus === 'Training' || dutyStatus === 'Standby'
  const enabled = !!crewId && !!startDate && !!endDate && isNonEligibleStatus
  return useQuery(
    orpc.roster.checkFlightAssignments.queryOptions({
      input: {
        crewId: crewId!,
        startDate: startDate!,
        endDate: endDate!,
      },
      enabled,
    })
  )
}

// Check flight assignments for deletion (always check, regardless of duty status)
export function useRosterCheckFlightAssignmentsForDelete(
  crewId: string | null,
  startDate: string | null, // YYYY-MM-DD
  endDate: string | null // YYYY-MM-DD
) {
  const orpc = useOrpcTanstackQueryUtils()
  const enabled = !!crewId && !!startDate && !!endDate
  return useQuery(
    orpc.roster.checkFlightAssignments.queryOptions({
      input: {
        crewId: crewId!,
        startDate: startDate!,
        endDate: endDate!,
      },
      enabled,
    })
  )
}
